import { DateTime } from "luxon";
import { stepsConfig } from "./formConfigAuto";

export const evaluateCondition = (condition, formState) => {
  if (!condition || !formState) return true;

  if (Array.isArray(condition)) {
    return condition.every((c) => evaluateCondition(c, formState));
  }

  const dependentAnswer = formState[condition.dependsOn];

  if (
    dependentAnswer === undefined ||
    dependentAnswer === null ||
    dependentAnswer === ""
  ) {
    return false;
  }

  switch (condition.operator || "equals") {
    case "equals":
      return (
        dependentAnswer === condition.value ||
        String(dependentAnswer) === String(condition.value)
      );
    case "not_equals":
      return dependentAnswer !== condition.value;
    case "in":
      return (
        Array.isArray(condition.value) &&
        condition.value.includes(dependentAnswer)
      );
    case "not_in":
      return (
        Array.isArray(condition.value) &&
        !condition.value.includes(dependentAnswer)
      );
    case "within_months": {
      const monthsLimit = Number(condition.value);
      if (isNaN(monthsLimit)) return false;
      const date = DateTime.fromISO(String(dependentAnswer));
      if (!date.isValid) return false;
      return date >= DateTime.now().minus({ months: monthsLimit });
    }
    default:
      return false;
  }
};

const OPTIONAL_CATEGORIES = ["garanties"];

const isEmptyAnswer = (value) =>
  value === undefined || value === null || value === "";

const REQUIRED_CATEGORIES = new Set(
  stepsConfig
    .map((step) => step.id)
    .filter((id) => !OPTIONAL_CATEGORIES.includes(id)),
);

export const isCompletionKnown = (formState, questionsConfig) =>
  !!formState && !!questionsConfig && Object.keys(questionsConfig).length > 0;

export const getMissingFields = (formState, questionsConfig) => {
  if (!isCompletionKnown(formState, questionsConfig)) return [];

  return Object.entries(questionsConfig)
    .filter(
      ([key, config]) =>
        REQUIRED_CATEGORIES.has(config.category) &&
        !config.optionnel &&
        evaluateCondition(config.condition, formState) &&
        isEmptyAnswer(formState[key]),
    )
    .map(([key, config]) => ({ key, label: config.label }));
};
